import { render, staticRenderFns } from "./SubGrupoProdutoModalPromotor.vue?vue&type=template&id=4839973d&scoped=true"
import script from "./SubGrupoProdutoModalPromotor.vue?vue&type=script&lang=js"
export * from "./SubGrupoProdutoModalPromotor.vue?vue&type=script&lang=js"
import style0 from "./SubGrupoProdutoModalPromotor.vue?vue&type=style&index=0&id=4839973d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839973d",
  null
  
)

export default component.exports